import { render, staticRenderFns } from "./LocationEmptyState.vue?vue&type=template&id=b6b507fc"
import script from "./LocationEmptyState.vue?vue&type=script&lang=js"
export * from "./LocationEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports